<template>
  <div class="serviceInfo">

    <template v-if="pkg.atts.length > 0">
      <img :src="pkg.atts[0].paths.origin_s3" style="width:100%; height:100%;"/>
    </template>

    <template v-else>
      <div :class="(pkg.is_assurance) ? '' : 'w50Im'">
        <h3><strong>20</strong>%</h3>
        <p>일반수리<br>할인</p>
      </div>

      <div v-if="pkg.is_assurance">
        <h3>연<strong>일천만</strong>원</h3>
        <p>{{$store.state.insuranceName.toUpperCase()}}</p>
      </div>

      <div :class="(pkg.is_assurance) ? '' : 'w50Im'">
        <h3>연<strong>1</strong>회</h3>
        <p>무상점검<br>서비스</p>
      </div>
    </template>
    
  </div>
</template>


<script>
  export default {
    props: {
      pkg: {
        type: Object,
        default() {
          return {
            title: '', is_assurance: false,
          }
        },
      },
    },
  }
</script>

<style scoped>
</style>

